import { render } from "./index.vue?vue&type=template&id=72009dfe"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=72009dfe&lang=less"

import exportComponent from "D:\\phpstudy_pro\\WWW\\tgl.liuxianfa.cn\\mobileNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__